import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PendingInvitationsRoutingModule } from './pending-invitations-routing.module';
import { PendingInvitationsComponent } from './pending-invitations/pending-invitations.component';
import { NavbarModule } from '../navbar/navbar.module';
import { PendingInvitationsHeaderComponent } from './pending-invitations-header/pending-invitations-header.component';
import { PendingInvitationsDataComponent } from './pending-invitations-data/pending-invitations-data.component';
import { PendingInvitationsFiltersComponent } from './pending-invitations-filters/pending-invitations-filters.component';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { PendingInvitationsDataTableComponent } from './pending-invitations-data-table/pending-invitations-data-table.component';
import { LoadingModule } from '../loading/loading.module';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { PendingInvitationsFilterDialogComponent } from './pending-invitations-filter-dialog/pending-invitations-filter-dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    PendingInvitationsComponent,
    PendingInvitationsHeaderComponent,
    PendingInvitationsDataComponent,
    PendingInvitationsFiltersComponent,
    PendingInvitationsDataTableComponent,
    PendingInvitationsFilterDialogComponent,
  ],
  imports: [
    CommonModule,
    PendingInvitationsRoutingModule,
    NavbarModule,
    ToolbarModule,
    LoadingModule,
    TranslateModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatTableModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
  ],
})
export class PendingInvitationsModule {}
